<template>
<div class="container">
  <play-button class="play" v-show="!playing"></play-button>
  <video :src="src" :controls="false" width="100%" @play="playing = true" @pause="playing = false" @ended="playing = false" @click="onClick" ref="video"></video>
</div>
</template>

<script>
import Vue from 'vue'

export default Vue.component('video-player', {
  props: ['src'],
  data: () => ({
    playing: false
  }),
  methods: {
    onClick(event) {
      if(this.playing) {
        this.$refs.video.pause()
      } else {
        this.$refs.video.play()
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  &:hover .play {
    transform: translate(-50%, -50%) scale(1.25);
  }
}
.play {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
}
video {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/video-player.vue